import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../utils/loadable';

const registrationInfo = Loadable(() => import('../containers/registrationInfo'));
export default MapTo('vcg/components/soe-home/react/registrationInfo')(registrationInfo);
